import "core-js/es/map";
import "core-js/es/set";
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import AppRouter from "./Router";

import "antd/dist/antd.min.css";
import "./assets/css/index.css";

const history = createBrowserHistory();

const render = (Component) => {
    return ReactDOM.render(
        <Router history={history}>
            <Component />
        </Router>,
        document.getElementById("root")
    );
};

render(AppRouter);
